var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssinaturaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.52.75a3.78 3.78 0 013.772 3.788V16.57a3.78 3.78 0 01-3.772 3.788 3.78 3.78 0 01-3.772-3.788V4.538A3.78 3.78 0 0110.52.75z",
    stroke: "#19759B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.753 10.448A3.78 3.78 0 014.525 6.66h11.991a3.78 3.78 0 013.772 3.788 3.78 3.78 0 01-3.772 3.787H4.526a3.78 3.78 0 01-3.773-3.787z",
    stroke: "#19759B",
    strokeWidth: 1.5
  })));
}
export default SvgAssinaturaIcon;